import React from 'react';
import { FaEye, FaGlasses, FaStethoscope } from 'react-icons/fa';
import SectionHeading from './ui/SectionHeading';

const services = [
  {
    icon: FaGlasses,
    title: 'Eyeglasses & sunglasses',
    description:
      'Browse stylish frames and lenses tailored to your prescription, face shape, and lifestyle — from everyday wear to designer collections.',
  },
  {
    icon: FaEye,
    title: 'Contact lenses',
    description:
      'Get a personalized fitting and the right lenses for comfort and clarity. We’ll help you choose dailies, monthlies, toric, or multifocal options.',
  },
  {
    icon: FaStethoscope,
    title: 'Eye exams',
    description:
      'Schedule a comprehensive eye exam with our optometrists. Protect your vision health with routine care, Monday through Saturday.',
  },
];

function ServicesSection() {
  return (
    <section id="services" className="bg-white py-16 md:py-24" aria-labelledby="services-heading">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeading
          id="services-heading"
          eyebrow="What we offer"
          title="Complete optical care"
          subtitle="Frames, lenses, contacts, and exams — everything you need for healthy sight and confident style."
        />
        <ul className="grid gap-8 md:grid-cols-3">
          {services.map(({ icon: Icon, title, description }) => (
            <li
              key={title}
              className="group flex flex-col rounded-2xl border border-slate-100 bg-white p-8 shadow-card transition-shadow duration-300 hover:shadow-card-hover"
            >
              <span className="mb-5 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-optical-100 text-optical-700 transition-transform duration-300 group-hover:scale-105">
                <Icon className="text-2xl" aria-hidden />
              </span>
              <h3 className="font-display text-xl font-semibold text-slate-900">{title}</h3>
              <p className="mt-3 flex-1 leading-relaxed text-slate-600">{description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default ServicesSection;
